import React from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./Clients.css";

const clientLogos = [
  "client1.png", "client2.png", "client3.png", "client4.png", "client5.png",
  "client6.png", "client7.png", "client8.png", "client9.png", "client10.png",
].map((file, index) => ({
  src: require(`../../asset/${file}`),
  alt: `Hardcoats client ${index + 1}`,
}));

const Clients = () => (
  <section className="clients-showcase" aria-labelledby="clients-title">
    <div className="clients-showcase__heading">
      <p>Trusted relationships</p>
      <h2 id="clients-title">Our clientele</h2>
      <span>Supporting organisations that depend on precision, reliability and consistent delivery.</span>
    </div>

    <Swiper
      className="clients-showcase__slider"
      modules={[Autoplay]}
      autoplay={{ delay: 1, disableOnInteraction: false, pauseOnMouseEnter: true }}
      loop
      speed={5000}
      allowTouchMove
      breakpoints={{ 0: { slidesPerView: 2 }, 560: { slidesPerView: 3 }, 800: { slidesPerView: 4 }, 1100: { slidesPerView: 5 } }}
    >
      {clientLogos.map((logo) => (
        <SwiperSlide key={logo.src}>
          <div className="client-logo-card"><img src={logo.src} alt={logo.alt} /></div>
        </SwiperSlide>
      ))}
    </Swiper>
  </section>
);

export default Clients;
